module.exports = __webpack_public_path__ + "7d088296/img/saly-icon.39e12342.jpg";